"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreIndex = exports.LoginType = void 0;
var LoginType;
(function (LoginType) {
    LoginType["google"] = "google";
    LoginType["reddit"] = "reddit";
    LoginType["discord"] = "discord";
    LoginType["twitch"] = "twitch";
    LoginType["github"] = "github";
    LoginType["twitter"] = "twitter";
})(LoginType = exports.LoginType || (exports.LoginType = {}));
var StoreIndex;
(function (StoreIndex) {
    StoreIndex["LOGGED_IN"] = "arc.user";
    StoreIndex["LOGIN_TYPE"] = "login_type";
    StoreIndex["STATE"] = "state";
})(StoreIndex = exports.StoreIndex || (exports.StoreIndex = {}));
